import { useCallback, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  disconnectCallTrackingProvider,
  getCallTrackingProviders,
} from '@user/store/callTracking'
import { useIsUnmounted, snackMachine } from '@sales-center/components'

type Props = {
  callProviderId: number
  name: string
}

export function useDisconnectHandler(props: Props) {
  const { callProviderId, name } = props
  const dispatch = useAppDispatch()
  const isUnmounted = useIsUnmounted()

  const [loading, setLoading] = useState(false)

  const handleDisconnect = useCallback(async () => {
    setLoading(true)
    const result = await dispatch(
      disconnectCallTrackingProvider(callProviderId),
    )

    if (isUnmounted()) return

    if (disconnectCallTrackingProvider.fulfilled.match(result)) {
      await dispatch(getCallTrackingProviders())
    } else {
      const errorMessage = `We are unable to Disconnect from ${name}`
      snackMachine.addSnack({
        severity: 'error',
        message: '',
        title: errorMessage,
      })
    }
    setLoading(false)
  }, [dispatch, name, callProviderId, isUnmounted])

  return {
    handleDisconnect,
    loading,
  }
}
